var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navList.length)?_c('ul',{staticClass:"navs-wrap flex-between"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index},[(item)?_c('AppItem',{attrs:{"data":item}}):_vm._e()],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }